import { productService } from "~/services/productService";

export const useTrendingProducts = () =>
    useAsyncData(
        "northland:product-trends",
        async () => {
            const res = await productService.getTrends();
            return res?.data ?? [];
        }
    );
